// seguimiento-form-modal.component.ts
import { Component, Input, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import Swal from "sweetalert2";
import { SeguimientoPlanRefuerzoService } from "../../../../../shared/services/seguimientoPlanRefuerzoComportamiento.service";

@Component({
  selector: "app-seguimiento-form-modal",
  templateUrl: "./seguimiento-form-modal.component.html",
  styleUrls: ["./seguimiento-form-modal.component.scss"],
})
export class SeguimientoFormModalComponent implements OnInit {
  @Input() idAccionRefuerzo!: number;
  @Input() seguimiento: any = null; // si viene, el modal opera en modo edición
  @Input() colaboradores: any[] = [];
  @Input() cargandoColaboradores = false;

  form!: FormGroup;
  guardando = false;
  get modoEdicion(): boolean {
    return !!this.seguimiento?.id;
  }

  compararPorCedula = (a: any, b: any): boolean => {
    const valorA = a && typeof a === "object" ? a.cedula : a;
    const valorB = b && typeof b === "object" ? b.cedula : b;
    if (valorA === valorB) return true;
    if (valorA === null || valorA === undefined || valorB === null || valorB === undefined) return false;
    return String(valorA).trim() === String(valorB).trim();
  };

  constructor(
    public activeModal: NgbActiveModal,
    private fb: FormBuilder,
    private seguimientoService: SeguimientoPlanRefuerzoService,
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      fecha_seguimiento: [
        this.seguimiento?.fecha_seguimiento || new Date().toISOString().substring(0, 10),
        Validators.required,
      ],
      cumplido: [!!this.seguimiento?.cumplido],
      responsable_seguimiento: [this.seguimiento?.responsable_seguimiento ?? null],
      observacion: [this.seguimiento?.observacion ?? null],
    });
  }

  guardar(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      Swal.fire("Campos obligatorios", "Completa la fecha de seguimiento.", "warning");
      return;
    }

    const formValue = this.form.getRawValue();
    const payload = {
      id_accion_refuerzo: this.idAccionRefuerzo,
      fecha_seguimiento: formValue.fecha_seguimiento,
      cumplido: !!formValue.cumplido,
      observacion: formValue.observacion,
      responsable_seguimiento: formValue.responsable_seguimiento,
    };

    this.guardando = true;

    const accion$ = this.modoEdicion
      ? this.seguimientoService.update(this.seguimiento.id, payload)
      : this.seguimientoService.create(payload);

    accion$.subscribe({
      next: () => {
        this.guardando = false;
        Swal.fire(
          "Éxito",
          `Seguimiento ${this.modoEdicion ? "actualizado" : "registrado"} correctamente.`,
          "success",
        );
        this.activeModal.close(true);
      },
      error: (error: any) => {
        this.guardando = false;
        const mensaje = error?.error?.error || "No se pudo guardar el seguimiento.";
        Swal.fire("Error", mensaje, "error");
      },
    });
  }

  cerrar(): void {
    this.activeModal.dismiss();
  }
}